var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseC flex-align-center"},[_c('div',[_c('img',{attrs:{"src":_vm.str}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }